import { EndpointNotFoundError, NodeNotFoundError, UnknownCommandError, } from "../error.js";
import { dumpNode } from "../state.js";
import { EndpointCommand } from "./command.js";
import { deserializeBufferInArray, getRawConfigParameterValue, setRawConfigParameterValue, } from "../common.js";
import { EndpointAccessControlMessageHandler } from "./access_control/message_handler.js";
export class EndpointMessageHandler {
    driver;
    client;
    subHandlers = {
        access_control: new EndpointAccessControlMessageHandler(),
    };
    constructor(driver, client) {
        this.driver = driver;
        this.client = client;
    }
    async handle(message) {
        const { nodeId, command } = message;
        let endpoint;
        const node = this.driver.controller.nodes.get(nodeId);
        if (!node) {
            throw new NodeNotFoundError(nodeId);
        }
        if (message.endpoint) {
            endpoint = node.getEndpoint(message.endpoint);
            if (!endpoint) {
                throw new EndpointNotFoundError(nodeId, message.endpoint);
            }
        }
        else {
            endpoint = node;
        }
        const subHandler = this.subHandlers[message.command.split(".")[1]];
        if (subHandler) {
            return subHandler.handle(message, endpoint);
        }
        switch (message.command) {
            case EndpointCommand.invokeCCAPI: {
                const response = await endpoint.invokeCCAPI(message.commandClass, message.methodName, ...deserializeBufferInArray(message.args));
                return { response };
            }
            case EndpointCommand.supportsCCAPI: {
                const supported = endpoint.supportsCCAPI(message.commandClass);
                return { supported };
            }
            case EndpointCommand.supportsCC: {
                const supported = endpoint.supportsCC(message.commandClass);
                return { supported };
            }
            case EndpointCommand.controlsCC: {
                const controlled = endpoint.controlsCC(message.commandClass);
                return { controlled };
            }
            case EndpointCommand.isCCSecure: {
                const secure = endpoint.isCCSecure(message.commandClass);
                return { secure };
            }
            case EndpointCommand.getCCVersion: {
                const version = endpoint.getCCVersion(message.commandClass);
                return { version };
            }
            case EndpointCommand.getNodeUnsafe:
            case EndpointCommand.tryGetNode: {
                const node = endpoint.tryGetNode();
                return {
                    node: node === undefined
                        ? node
                        : dumpNode(node, this.client.schemaVersion),
                };
            }
            case EndpointCommand.setRawConfigParameterValue: {
                return setRawConfigParameterValue(message, endpoint);
            }
            case EndpointCommand.getRawConfigParameterValue: {
                return getRawConfigParameterValue(message, endpoint);
            }
            case EndpointCommand.getCCs: {
                const commandClasses = Object.fromEntries(endpoint.getCCs());
                return { commandClasses };
            }
            case EndpointCommand.maySupportBasicCC: {
                const maySupport = endpoint.maySupportBasicCC();
                return { maySupport };
            }
            case EndpointCommand.wasCCRemovedViaConfig: {
                const removed = endpoint.wasCCRemovedViaConfig(message.commandClass);
                return { removed };
            }
            default: {
                throw new UnknownCommandError(command);
            }
        }
    }
}
